import React, { useEffect, useRef, useState } from 'react';
import { TbCopy } from 'react-icons/tb';

const copyResponseText = async (text) => {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);

  try {
    textarea.select();
    if (!document.execCommand('copy')) throw new Error('Clipboard unavailable.');
  } finally {
    textarea.remove();
  }
};

const shouldShowResponseCopy = (message) => message?.role === 'assistant' && !message.disabled;

const AssistantResponseLayout = ({ cardStyle, children, resources, copyContent, showCopy }) => (
  <div className='aes-ai-chat-assistant-message'>
    <div className='aes-ai-chat-messages-bot' style={cardStyle}>
      {children}
      {resources && (
        <>
          <hr className='aes-ai-chat-response-divider' />
          <div className='aes-ai-chat-response-resources'>{resources}</div>
        </>
      )}
    </div>
    {showCopy && <AssistantResponseCopy content={copyContent} />}
  </div>
);

const AssistantResponseCopy = ({ content }) => {
  const [copied, setCopied] = useState(false);
  const feedbackTimeout = useRef(null);

  useEffect(() => () => clearTimeout(feedbackTimeout.current), []);

  const copy = async () => {
    try {
      await copyResponseText(content || '');
      setCopied(true);
      clearTimeout(feedbackTimeout.current);
      feedbackTimeout.current = setTimeout(() => setCopied(false), 1600);
    } catch {
      setCopied(false);
    }
  };

  const label = copied ? 'Copied' : 'Copy response';

  return (
    <button
      type='button'
      className={`aes-ai-chat-response-copy${copied ? ' is-copied' : ''}`}
      title={label}
      aria-label={label}
      onClick={copy}
    >
      <TbCopy aria-hidden='true' focusable='false' />
    </button>
  );
};

export { AssistantResponseLayout, copyResponseText, shouldShowResponseCopy };
export default AssistantResponseCopy;
